import axios from 'axios';

function api(token) {
  const axiosInstance = axios.create({
    responseType: 'json'
  });
  
  axiosInstance.defaults.headers.post['Content-Type'] = 'application/json';
  axiosInstance.defaults.baseURL = process.env.REACT_APP_INTEGRATION_URL;
    
  if (token) {
    axiosInstance.defaults.headers.Authorization = `Bearer ${token}`;
  }

  return axiosInstance;
}

export default api;
